// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2mmFn","lastUpdated":"PrivacyPolicy_lastUpdated__I83M1","tbox":"PrivacyPolicy_tbox__JI-Gw","accordionItem":"PrivacyPolicy_accordionItem__1PPVe"};